var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArblogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 38,
    viewBox: "0 0 29 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_593)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_145_593)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_145_593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 29,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4391 3.31006H0.000976562V34.6901H28.4391V3.31006Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_145_593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6035 21.3845L15.0476 25.5501C15.0017 25.6656 15.0017 25.7939 15.0476 25.9095L17.7194 33.079L20.8114 31.3331L17.1024 21.3845C17.017 21.1534 16.6888 21.1534 16.6035 21.3845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7147 14.3754C19.6294 14.1444 19.3012 14.1444 19.2158 14.3754L17.66 18.541C17.614 18.6566 17.614 18.785 17.66 18.9005L22.0386 30.64L25.1306 28.8941L19.7147 14.3754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.22 5.25486C14.2988 5.25486 14.3711 5.27411 14.4432 5.31263L26.2334 11.9686C26.3713 12.0456 26.4566 12.1868 26.4566 12.3409V25.6528C26.4566 25.8069 26.3713 25.9481 26.2334 26.0251L14.4432 32.6875C14.3776 32.726 14.2988 32.7453 14.22 32.7453C14.1413 32.7453 14.069 32.726 13.9968 32.6875L2.21327 26.0315C2.07541 25.9545 1.99007 25.8132 1.99007 25.6593V12.3409C1.99007 12.1868 2.07541 12.0456 2.21327 11.9686L14.0034 5.31263C14.069 5.27411 14.1479 5.25486 14.22 5.25486ZM14.22 3.31006C13.7999 3.31006 13.3797 3.41917 13.0055 3.63098L1.21544 10.287C0.467068 10.7106 0.000976562 11.4936 0.000976562 12.3409V25.6528C0.000976562 26.5001 0.467068 27.2896 1.21544 27.7132L13.0055 34.3691C13.3797 34.5809 13.7999 34.6901 14.22 34.6901C14.6401 34.6901 15.0603 34.5809 15.4345 34.3691L27.2246 27.7132C27.9796 27.2896 28.4391 26.5064 28.4391 25.6528V12.3409C28.4391 11.4936 27.973 10.7042 27.2246 10.2805L15.4411 3.63098C15.0603 3.41917 14.6401 3.31006 14.22 3.31006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42871 30.6528L7.51188 27.7517L9.69135 29.5232L7.6563 31.346L6.42871 30.6528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2284 11.3909H10.2415C10.0183 11.3909 9.81474 11.5257 9.74256 11.731L3.33545 28.9069L6.42741 30.6527L13.4844 11.7375C13.5435 11.5706 13.4187 11.3909 13.2284 11.3909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4597 11.3909H15.4728C15.2496 11.3909 15.0461 11.5257 14.9739 11.731L7.6543 31.3459L10.7462 33.0918L18.7092 11.7439C18.7748 11.5706 18.6436 11.3909 18.4597 11.3909Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.44,
    height: 31.38,
    fill: "white",
    transform: "translate(0 3.31006)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_145_593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4381,
    height: 31.38,
    fill: "white",
    transform: "translate(0.000976562 3.31006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArblogo);
export default __webpack_public_path__ + "static/media/arblogo.ba5008786f476b8338c7fe200b351db9.svg";
export { ForwardRef as ReactComponent };